import { Routes, Route, Navigate } from "react-router-dom";
import Landing from "./pages/Landing";
import Auth from "./pages/Auth";
import CreateAgent from "./pages/CreateAgent";
import Town from "./pages/Town";
import { getToken } from "./api";

function Guard({ children }: { children: JSX.Element }) {
  if (!getToken()) return <Navigate to="/auth" replace />;
  return children;
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/auth" element={<Auth />} />
      <Route path="/create-agent" element={<Guard><CreateAgent /></Guard>} />
      <Route path="/town" element={<Guard><Town /></Guard>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
